'use client';
import { Header } from '@/components/header/Header';
import Footer from '@/components/footer/Footer';
import RootWrapper from '@/lib/_components/RootWrapper';
import React, { ReactNode } from 'react';
import { cn } from '@/lib/_utils/cn';
import { GtmEventTrackingProps } from '@/lib/_components/GtmEventTracking';
import { BottomNav } from '@/components/BottomNav/BottomNav.tsx';

const global: Record<'bg_square', string> = {
	bg_square: "bg-[url('/app/auth/auth-bg.svg')] [background-size:calc(max(100%,2732px))] bg-center bg-fixed",
};

export type LayoutType = {
	style?: { global?: 'bg_square' };
	children: ReactNode;
	fullscreen?: boolean;
	responsive?: boolean;
	headerChildren?: ReactNode;
	headerClassName?: string;
	layoutProps?: JSX.IntrinsicElements['div'];
	mainProps?: JSX.IntrinsicElements['main'];
	gtmEventTrackingProps?: GtmEventTrackingProps;
	isFooterEnabled?: boolean;
};

export default function Layout({ ...props }: LayoutType) {
	const {
		style,
		children,
		fullscreen,
		headerChildren,
		headerClassName,
		layoutProps,
		mainProps,
		gtmEventTrackingProps,
		isFooterEnabled = true,
	} = props;
	const fullscreenClass = fullscreen ? 'h-[100dvh]' : 'min-h-[100dvh]';
	const bgClass = style?.global && (style?.global as 'bg_square') ? global[style?.global] : '';
	const { className: layoutPropsClassName = '', ...restLayoutProps } = layoutProps || {};

	return (
		<RootWrapper gtmEventTrackingProps={gtmEventTrackingProps}>
			<div
				className={`${cn('flex min-h-[500px] w-full flex-1 flex-col', fullscreenClass, bgClass, layoutPropsClassName)}`}
				{...restLayoutProps}>
				<Header className={headerClassName}>{headerChildren}</Header>
				<main className={`h-0 flex-1`} {...mainProps}>
					{children}
				</main>
				{isFooterEnabled && <Footer />}
				<BottomNav />
			</div>
		</RootWrapper>
	);
}
